module.exports = __webpack_public_path__ + "fonts/Montserrat-Medium.ee130b4.ttf";